import { useConfig as hook, BaseConfig } from '@eika-infrastruktur/config-provider';
import { AttentionMessageTypes } from '@eika/attention-message';

export interface MalbankLink {
    Anchor?: string;
    Class?: string;
    Query?: string;
    Target?: string;
    TargetId?: string;
    Text?: string;
    Title?: string;
    Url?: string;
}

export interface ScLink {
    Anchor?: string;
    Class?: string;
    Query?: string;
    Title?: string;
    Url: string;
    Name?: string;
    Target?: string;
    TargetId?: string;
    Type?: number;
    Style?: string | null;
}

export interface ScMenuItem {
    Id: string;
    Name: string;
    Link: ScLink;
    IsActive?: boolean;
    IsExternalLink?: boolean;
    SubMenuItems?: ScSubMenuItem[];
}

export interface ScSubMenuItem {
    Id: string;
    Name: string;
    Link: ScLink;
    IsActive?: boolean;
    IsExternalLink?: boolean;
}

export interface ScNativeMenuItem {
    Id: string;
    Name: string;
    Link: ScLink;
    Small?: boolean;
}

export interface ScLogo {
    Src: string;
    AltText: string;
    HomePath: string;
}

export interface HeaderAttentionMessage {
    Id?: string;
    Message: string;
    Type?: AttentionMessageTypes;
    IsNative?: boolean;
    Link?: {
        Anchor: string;
        Text: string;
    };
}

export interface HeaderApp {
    SrcRoot: string;
    Namespace: string;
    Config: Record<string, string>;
}

export interface Config extends BaseConfig {
    PageName?: string;
    Frontpage: boolean;
    MenuItems: ScMenuItem[] | null;
    NativeMenuItems: ScNativeMenuItem[] | null;
    Logo?: ScLogo;
    IsNative: boolean;
    LogoutUrl: string;
    LogoutButtonText: string;
    AttentionMessage?: HeaderAttentionMessage;
    ShowAttentionMessage?: boolean;
    BankLink?: MalbankLink;
    HeaderApp?: HeaderApp;
}

export const defaultConfig: Config = {
    Frontpage: false,
    MenuItems: [],
    NativeMenuItems: [],
    IsNative: false,
    LogoutUrl: '',
    LogoutButtonText: '',
    ShowAttentionMessage: false,
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
